import React from 'react';
import type { FC } from 'react';
import { Box } from '@wix/cli-ui-kit';
import { ContactUs } from './ContactUs.js';

export const UserFeedbackFallback: FC = () => {
  return (
    <Box flexDirection="column" marginTop={1}>
      <ContactUs />
    </Box>
  );
};
